import { ICards } from "@root/core/interfaces/CardTotal";
import { Card, Col } from "antd";
import React from "react";

const Statistics: React.FC<ICards> = (props) => (
  <Col span={4}>
    <Card title={props.title} bordered={false}>

      <h1 style={{ fontSize: 22 }}>
        {Intl.NumberFormat().format(props.number)}
      </h1>

    </Card>
  </Col>
);
export default Statistics;
